import React from 'react';
import TaraCallback from "../shared/Authorization/TaraCallback";

// Private base
const Admin = React.lazy(() => import("../modules/Base"));

// Public components
const Home = React.lazy(() => import("../modules/Public/Home/Home"));
const Auth = React.lazy(() => import("../modules/Public/Auth/Auth"));
const CreateProblem = React.lazy(() => import("../modules/Public/Problem/CreateProblem"));
const ViewProblem = React.lazy(() => import("../modules/Public/Problem/ViewProblem"));
const Tenders = React.lazy(() => import("../modules/Public/Tender/Tenders"));
const Tender = React.lazy(() => import("../modules/Public/Tender/Tender"));
const Map = React.lazy(() => import("../modules/Public/Map/Map"));
const Problem = React.lazy(() => import("../modules/Public/Problem/Problem"));
const CityObject = React.lazy(() => import("../modules/Public/Object/CityObject"));
const Article = React.lazy(() => import("../modules/Public/Article/Article"));

export const publicRoutes = [
    {
        title: 'Main',
        path: '/',
        component: Home
    },
    {
        title: 'Add a new problem',
        path: '/add',
        component: CreateProblem
    },
    {
        title: 'View problem',
        path: '/mv/:uid',
        component: ViewProblem
    },
    {
        title: 'Authorization',
        path: '/auth',
        component: Auth
    },
    {
        title: 'TaRa authorization callback page',
        path: '/auth/tara_callback',
        component: TaraCallback
    },
    {
        title: 'Tenders',
        path: '/tenders',
        component: Tenders
    },
    {
        title: 'View tender',
        path: '/tenders/:id',
        component: Tender
    },
    {
        title: 'Map',
        path: '/map',
        component: Map
    },
    {
        title: 'View problem',
        path: '/problems/:id',
        component: Problem
    },
    {
        title: 'View object',
        path: '/objects/:id',
        component: CityObject
    },
    {
        title: 'Article',
        path: '/cookie_policy',
        component: Article
    }
];

export const routes = [
    {
        title: 'Manager',
        path: '/private/*',
        component: Admin
    },
];
